function MediumAccountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.852} width={14.341} height={14.341} rx={1.646} fill="#14B8A6" />
      <rect
        x={17.829}
        y={0.852}
        width={14.341}
        height={14.341}
        rx={1.646}
        fill="#14B8A6"
      />
      <rect
        x={36.208}
        y={1.4}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#14B8A6"
        strokeWidth={1.097}
      />
    </svg>
  )
}

export default MediumAccountIcon
